module.exports = __webpack_public_path__ + "report-2ace5e2a006e7e1e04be.png";